var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 58,
    viewBox: "0 0 52 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.2388 45.2383C50.0961 44.1668 51.2404 42.1855 51.2404 40.0413V17.9587C51.2404 15.8145 50.0961 13.8332 48.2388 12.7617L29.1187 1.73002C27.263 0.659386 24.9773 0.659384 23.1217 1.73002L4.00151 12.7617C2.14425 13.8332 1 15.8145 1 17.9587V40.0413C1 42.1855 2.14425 44.1668 4.00151 45.2383L23.1217 56.27C24.9773 57.3406 27.263 57.3406 29.1187 56.27L48.2388 45.2383Z",
    fill: "url(#paint0_radial_18355_93813)",
    stroke: "url(#paint1_linear_18355_93813)",
    strokeWidth: 1.29612
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.863 30.2368V24.6251C39.863 17.6105 37.0572 14.8047 30.0426 14.8047H21.6251C14.6105 14.8047 11.8047 17.6105 11.8047 24.6251V33.0426C11.8047 40.0572 14.6105 42.863 21.6251 42.863H27.2368",
    stroke: "#EEEEEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2852 32.3303L22.6241 27.9953C23.1011 27.378 23.9849 27.2658 24.6022 27.7427L27.1696 29.763C27.7869 30.2399 28.6707 30.1277 29.1477 29.5245L32.3884 25.3438",
    stroke: "#EEEEEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3274 34.1938L36.7202 34.9934C36.9166 35.3862 37.4076 35.751 37.8425 35.8352L38.3756 35.9193C39.975 36.1859 40.3537 37.3643 39.2033 38.5288L38.7123 39.0198C38.3896 39.3565 38.2073 40.0018 38.3055 40.4508L38.3756 40.7454C38.8105 42.6814 37.7864 43.4249 36.1029 42.4148L35.7381 42.2044C35.3032 41.9519 34.6018 41.9519 34.1669 42.2044L33.8021 42.4148C32.1046 43.439 31.0805 42.6814 31.5294 40.7454L31.5995 40.4508C31.6977 40.0018 31.5154 39.3565 31.1927 39.0198L30.7017 38.5288C29.5513 37.3643 29.9301 36.1859 31.5294 35.9193L32.0625 35.8352C32.4834 35.765 32.9884 35.3862 33.1848 34.9934L33.5776 34.1938C34.3352 32.6646 35.5698 32.6646 36.3274 34.1938Z",
    stroke: "#EEEEEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_18355_93813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.1202 29) rotate(90) scale(57.5167 49.8217)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18355_93813",
    x1: 4.99639,
    y1: 2.41667,
    x2: 41.5768,
    y2: 63.7624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289672,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696447,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrand);
export default __webpack_public_path__ + "static/media/brand.11194bfa804ab8794001f0b917ba5703.svg";
export { ForwardRef as ReactComponent };